import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import DeletedLabel from "components/DeletedLabel";
import statusActive from "assets/images/city/statusActive.svg";
import statusInactive from "assets/images/city/statusInactive.svg";
import CreditCardIcon from "@mui/icons-material/CreditCard";

function Author({ image, name }) {
  return (
    <SoftBox display="flex" minWidth="300px" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar src={image} alt={name} size="sm" />
      </SoftBox>
      <Link>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography
            sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
            fontWeight="normal"
          >
            {name}
          </SoftTypography>
        </SoftBox>
      </Link>
    </SoftBox>
  );
}

export const columns = [
  { name: "school", align: "left" },
  { name: "domain", align: "left" },
  { name: "users", align: "left" },
  { name: "status", align: "center" },
  { name: "subscription required", align: "center" },
  { name: "action", align: "left" },
];

function Rows(data, setDialogue, returnPath) {
  return {
    linkPath: `/school-details/${data?._id}`,
    returnPath,
    noLinkCells: ["action", "status"],
    users: (
      <SoftBox display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
          fontWeight="normal"
        >
          {data?.users || 0}
        </SoftTypography>
      </SoftBox>
    ),

    school: <Author name={data?.school_name} image={data?.school_image} />,

    domain: (
      <SoftBox minWidth="200px" display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "lowercase" }}
          fontWeight="normal"
        >
          {data?.school_domain}
        </SoftTypography>
      </SoftBox>
    ),

    status: (
      <SoftBox
        minWidth="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={(event) => {
          event.stopPropagation();
          !data?.is_deleted &&
            setDialogue({
              type: "changeStatus",
              isOpen: true,
              action: "",
              schoolID: data?._id,
            });
        }}
        sx={{ cursor: data?.is_deleted ? "default" : "pointer" }}
      >
        {data?.is_deleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            ---
          </SoftBox>
        ) : (
          <SoftBox
            component="img"
            src={data?.is_active ? statusActive : statusInactive}
            alt={data?.is_active ? "Active" : "Inactive"}
            sx={{
              width: data?.is_active ? 30 : 31,
              height: 20,
              display: "block",
            }}
          />
        )}
      </SoftBox>
    ),

    "subscription required": (
      <SoftBox
        minWidth="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={(event) => {
          event.stopPropagation();
          !data?.is_deleted &&
            setDialogue({
              type: "changeSubscriptionRequired",
              isOpen: true,
              action: "",
              schoolID: data?._id,
              name: data?.school_name,
              subscription_required: data?.subscription_required,
            });
        }}
        sx={{ cursor: data?.is_deleted ? "default" : "pointer" }}
      >
        {data?.is_deleted ? (
            <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
              ---
            </SoftBox>
          ) : (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
            px={1}
            py={0.5}
            borderRadius="xxl"
            sx={{
              backgroundColor: "purple.light",
            }}
          >
            <SoftBox
              component="img"
              src={data?.subscription_required ? statusActive : statusInactive}
              alt={data?.subscription_required ? "Active" : "Inactive"}
              sx={{
                width: data?.subscription_required ? 30 : 31,
                height: 20,
                display: "block",
              }}
            />
            {/* <CreditCardIcon sx={{ height: 16, width: 16, color: "purple.main" }} />
            <SoftTypography
              sx={{ fontSize: 12, color: "purple.main", fontWeight: "normal" }}
            >
              {data?.subscription_required ? "Yes" : "No"}
            </SoftTypography> */}
          </SoftBox>
        )}
      </SoftBox>
    ),

    action: (
      <>
        {data?.is_deleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            <SoftBox height="30px" />
            <DeletedLabel />
          </SoftBox>
        ) : (
          <SoftBox display="flex" alignItems="start" justifyContent="start" gap={1}>
            <SoftBox
              component={Link}
              to={`/edit-school/${data?._id}`}
              state={returnPath ? { from: returnPath } : undefined}
              borderRadius="xxl"
              display="flex"
              sx={{
                backgroundColor: "light.main",
                width: "80px",
                py: 0.8,
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <NoteAltOutlinedIcon sx={{ height: 20, width: 20, color: "yellow.main" }} />
              <SoftTypography
                fontWeight="normal"
                sx={{ color: "yellow.main", fontSize: 13, textTransform: "capitalize" }}
              >
                Edit
              </SoftTypography>
            </SoftBox>

            <SoftBox
              onClick={(event) => {
                event.stopPropagation();
                setDialogue({
                  type: "deleteUniversity",
                  isOpen: true,
                  action: "",
                  schoolID: data?._id,
                });
              }}
              borderRadius="xxl"
              display="flex"
              sx={{
                backgroundColor: "red.light",
                width: "80px",
                py: 0.8,
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <DeleteIcon sx={{ height: 20, width: 20, color: "red.main" }} />
              <SoftTypography
                fontWeight="normal"
                sx={{ color: "red.main", fontSize: 13, textTransform: "capitalize" }}
              >
                Delete
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        )}
      </>
    ),
  };
}

export default Rows;
